
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HistoryPage = lazy(() => import('../pages/about/history/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const STSPanelPage = lazy(() => import('../pages/process/sts-panel/page'));
const STSCylinderPage = lazy(() => import('../pages/process/sts-cylinder/page'));
const LiningPage = lazy(() => import('../pages/process/lining/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const LocationPage = lazy(() => import('../pages/location/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const QuotePage = lazy(() => import('../pages/quote/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/about/history', element: <HistoryPage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/process', element: <ProcessPage /> },
  { path: '/process/sts-panel', element: <STSPanelPage /> },
  { path: '/process/sts-cylinder', element: <STSCylinderPage /> },
  { path: '/process/lining', element: <LiningPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/location', element: <LocationPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/quote', element: <QuotePage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
